<router-outlet />
<fl-cookie-consent-container />
<fl-view-settings-container />
<p-confirm-dialog [draggable]="false" #cd [style]="{ width: '400px' }">
  <ng-template pTemplate="footer">
    <button data-qa="button-reject" type="button" pButton icon="pi pi-times" (click)="cd.onReject()">
      {{ cd.rejectLabel ?? "COMMON.NO" | translate }}
    </button>
    <button data-qa="button-confirm" type="button" pButton icon="pi pi-check" (click)="cd.onAccept()">
      {{ cd.acceptLabel ?? "COMMON.YES" | translate }}
    </button>
  </ng-template>
</p-confirm-dialog>
